export default __webpack_public_path__ + "static/media/help-rav-inv-18.41163b90.png";